import {deleteObject, getDownloadURL, ref as storage_ref, uploadBytesResumable} from "firebase/storage";
import { storage } from "../firebase";
import { useContext, useReducer, useRef, useState } from "react";
import './newIndex.css';
import hbrIcon from "../otherImg/hbrlitenewicon.png";
import { Button } from "@mui/material";
import { useEffect } from "react";
import { AuthContext } from "../AuthContext";
import { format } from "date-fns";
import { HbrArrowRight, HbrAvatarProfile2, Hbrbackarrow, HbrCloseIcon } from "./Mycustomsvgicons";
import { useLocation, useNavigate } from "react-router-dom";
import { DisplayUserPicAndName, getMediaStoragePath, sanitizeText } from "./GeneralClasses";
import Authaxios from "../newComponents2/Authaxios";
import { actionConsts, actionConts2, reducer } from "./StateManager";
import { ConstVariables } from "../newComponents2/ConstantVariables";
import { CustomAlertDialog } from "./CustomAlertDialog";
import { CustomConfirmDialog } from "./Customconfirmdialog";
import ChangePassword from "../newComponents2/ChangePassword";
import OptionalDialog from "../newComponents2/OptionalDialog";



const UpdateProfile = () => {
    const [newUserHandle,setUserName]=useState("");
    const [aboutText,setAboutText]=useState("");
    const [myPic, setMyPic]=useState("");
    const [success,setSuccess]=useState(false);
    const [selectedImage,SetSelectedImage] = useState(null);
    const [loading,setLoading]=useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [changePasswd, setChangePasswd] = useState(false);
    const [checked, setChecked] = useState(false);
    const [state,dispatch]=useReducer(reducer,{alertMessage: "", showAlert: false, showConfirmDialog: false, vcode: "", showOptionalDialog: false});
    const today = new Date();
    const imageid = format(today,"yyyyMMddHHmmss");
    const navigate = useNavigate();
    const location = useLocation();
    const {user_email} = useContext(AuthContext);
    const errRef = useRef();

    const messageBody = ConstVariables.MAIL_BODY_RESET_PASS;
    const messageTitle = ConstVariables.MAIL_TITLE_RESET_PASS;


    useEffect(()=>{
        async function getUserInfo() {
            const userInfo = await DisplayUserPicAndName(user_email);
            if (userInfo) {
                const nameFromDB = userInfo.name && userInfo.name !== "" ? userInfo.name : "";
                setUserName(nameFromDB);
                setAboutText(userInfo.bio);
                setMyPic(userInfo.profilePic);
            };
        }
        getUserInfo();
    },[user_email]);


    const handleClosePage=()=>{
        if (location.state && location.state.from) {
            navigate(location.state.from);
        }else{
            navigate("/");
        }
    };

    const deletePrevPicture=async()=>{
        if (myPic && myPic !== "") {
            const pictureRef = storage_ref(storage, getMediaStoragePath(myPic))
            await deleteObject(pictureRef);
            console.log("previous picture deleted");
        }
    };

    const verifyUserCredential=async()=>{
        if (user_email.trim() === "") {
          dispatch({type: actionConsts.ALERT_MESSAGE,payload: 'Forgotten password? To help you reset your password, enter your account email to receive verification code.'});
          dispatch({type: actionConsts.SHOWALERT,payload: true});
          return;
        }
        try {
            setLoading(true);
            const res = await Authaxios.post("/sendOtp",
                JSON.stringify({email: user_email, messageBody, messageTitle}),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: false
                }
            );
            dispatch({type: actionConts2.OTP, payload: res.data.vcode});
            setLoading(false);
            dispatch({type: actionConsts.CONFIRMDIALOG, payload: true});
        } catch (error) {
            if (!error?.response) {
                dispatch({type: actionConsts.ALERT_MESSAGE,payload: ConstVariables.NO_SERVER_RESPONSE});
                dispatch({type: actionConsts.SHOWALERT,payload: true});
                setErrMsg(ConstVariables.NO_SERVER_RESPONSE)
            }else if (error?.response.status === 500) {
                dispatch({type: actionConsts.ALERT_MESSAGE,payload: ConstVariables.SERVICE_UNAVAILABLE});
                dispatch({type: actionConsts.SHOWALERT,payload: true});
                setErrMsg(ConstVariables.SERVICE_UNAVAILABLE);
            }else if (error?.response.status === 401) {
                dispatch({type: actionConsts.ALERT_MESSAGE,payload: `The provided email address ${user_email} is not valid. Enter a valid email address to receive verification code.`});
                dispatch({type: actionConsts.SHOWALERT,payload: true});
                setErrMsg("invalid email");
            }else{
                dispatch({type: actionConsts.ALERT_MESSAGE,payload: ConstVariables.UNKNOWN_ERROR});
                dispatch({type: actionConsts.SHOWALERT,payload: true});
                setErrMsg(ConstVariables.UNKNOWN_ERROR);
            }
            setLoading(false);
            errRef.current.focus();
        }
      };

      const handleCallback=(inputValue)=>{
        if (inputValue === state.vcode) {
            dispatch({type: actionConsts.CONFIRMDIALOG, payload: false});
            setChangePasswd(true);
        }else{
            dispatch({type: actionConsts.ALERT_MESSAGE,payload: `Invalid verification code`});
            dispatch({type: actionConsts.SHOWALERT,payload: true});
        }
        dispatch({type: actionConts2.OTP, payload: ""});
      };
    
    const updateAccount = async(e)=>{
        e.preventDefault();
            if(selectedImage){
                try{
                    setLoading(true);
                    const storageRef = storage_ref(storage,`user_profile/${newUserHandle+imageid}`);
                    const uploadTask = uploadBytesResumable(storageRef, selectedImage);
                    uploadTask.on(
                        (error)=>{
                        console.log(error);
                        },
                        ()=>{
                            getDownloadURL(uploadTask.snapshot.ref).then(async(downloadUrl)=>{
                                try {
                                    await Authaxios.post("/updateProfile",
                                        JSON.stringify({userName:newUserHandle, user_email, password:null, profile_pic:downloadUrl, bio:aboutText, api_key:process.env.REACT_APP_CONNECTERE_KEY}),
                                        {
                                            headers: { 'Content-Type': 'application/json' },
                                            withCredentials: false
                                        }
                                      );
                                      deletePrevPicture();
                                      localStorage.setItem("userName", newUserHandle);
                                      localStorage.setItem("userEmail",user_email);
                                      localStorage.setItem("userProfile", downloadUrl);
                                      setSuccess(true);
                                      setLoading(false);
                             
                                } catch (err) {
                                    if (!err?.response) {
                                        setErrMsg("No server response, Try again later")
                                      }else if (err?.response.status === 500) {
                                          setErrMsg(`Service unavailable at the moment. Sorry ${newUserHandle} we are currently working to restore all services.`);
                                      }else{
                                          setErrMsg("profile update interrupted. Try again later or contact support team");
                                      }
                                      setLoading(false);
                                      errRef.current.focus();
                                }
                            })
                            .catch((error)=>{
                                console.log(error);
                            });
                        }
                    );

                }catch(error){
                    setSuccess(false);
                    setLoading(false);
                    setErrMsg("Error occurred while changing profile");
                    console.log(error);
                }
            }else{
                try {
                    await Authaxios.post("/updateProfile",
                        JSON.stringify({userName:newUserHandle, user_email, password:null, profile_pic: myPic, bio:aboutText, api_key:process.env.REACT_APP_CONNECTERE_KEY}),
                        {
                            headers: { 'Content-Type': 'application/json' },
                            withCredentials: false
                        }
                      );
                      localStorage.setItem("userName", newUserHandle);
                      localStorage.setItem("userEmail",user_email);
                      localStorage.setItem("userProfile", myPic);
                      setSuccess(true);
                      setLoading(false);
                } catch (err) {
                    if (!err?.response) {
                        setErrMsg("No server response, Try again later")
                      }else if (err?.response.status === 500) {
                          setErrMsg(`Service unavailable at the moment. Sorry ${newUserHandle} we are currently working to restore all services.`);
                      }else{
                          setErrMsg("profile update interrupted. Try again later or contact support team");
                      }
                      setLoading(false);
                      errRef.current.focus();
                }
            }     
    };

    useEffect(()=>{
        const persistLogin = localStorage.getItem("persistLogin");
        if (persistLogin && persistLogin === "true") {
            setChecked(true);
        }
    },[]);

    const handlePersistLogin=(e)=>{
        if (e.target.checked) {
          localStorage.setItem("persistLogin", true);
          setChecked(true);
        }else{
          localStorage.setItem("persistLogin", false);
          setChecked(false);
        }
    };

    const handleSignOut=()=>{
        localStorage.removeItem("userName");
        localStorage.removeItem("userEmail");
        localStorage.removeItem("userProfile");
        localStorage.removeItem("persistLogin");
        navigate("/");
    };


    return !changePasswd ? ( 
        <div className="useraccount">

            {state.showAlert &&
                <CustomAlertDialog alertmessage={state.alertMessage} handleCloseDialog={()=>dispatch({type: actionConsts.SHOWALERT,payload: false})}/>
            }

            {state.showConfirmDialog &&
                <CustomConfirmDialog
                title={"User Verification"}
                formDesc={`Enter the verification code sent to ${user_email}. Request new code after: `}
                showTimer={true}
                callback={handleCallback}
                positiveBtn={"Validate"}
                closeDialog={()=> dispatch({type: actionConsts.CONFIRMDIALOG, payload: false})}
                />
            }

            {state.showOptionalDialog && 
                <OptionalDialog 
                    message={"The action you are about to take will sign you out from your current account and all associated data related to the account. Are you sure you want to sign out from your current account?"}
                    positiveBtn={"Sign out"}
                    negBtn={"Cancel"}
                    positiveAction={handleSignOut}
                    negativeAction={()=>dispatch({type: actionConts2.OPTIONAL_DIALOG, payload: false})}
                />
            }
             
                <div className="flex-spacearound" style={{width: "100%"}}>
                    <Hbrbackarrow width={"2em"} height={"2em"} fillColour={"white"} handleClick={()=>handleClosePage()}/>
                        <div className="flex-row2">
                            <Button style={{color: "white"}} onClick={()=>navigate(`/profilepage?hbruserref=${sanitizeText(user_email)}&socialhandle=${newUserHandle}`, 
                            {state: {from: location.pathname}})}>
                            View Profile
                            </Button>

                            <HbrArrowRight width={"2em"} height={"2em"} fillColour={"white"}/>
                        </div>
            
                </div>

                <div className="formWrapper">
                    {loading && 
                        <div style={{
                            position:"absolute",
                            top:"50%",
                            left:"45%",
                            width:"fit-content",
                            height:"fit-content",
                            border: "5px solid #00000050",
                            borderTop: "5px solid #eb268f",
                            borderBottom: "5px solid Teal",
                            borderRadius: "50%",
                            animation: "spin2 2s linear infinite",
                            backgroundColor: "#FFFFFF",
                            zIndex:"3"
                            }}>
                            <p>updating profile...</p>
                        </div>
                    }  

                    <div className="arrangeformheading">
                        <p>Update Profile</p>
                        <img src={hbrIcon} alt="" />
                    </div>

                    <form onSubmit={updateAccount} className="formcontents">
                    <p ref={errRef} className={errMsg ? "errmsg" : "hideerrmsg"} aria-live="assertive">{errMsg}</p>
                        <label htmlFor="file" className="selectImage" >
                                {!selectedImage && myPic === "" &&
                                  <HbrAvatarProfile2 width={"10em"} height={"10em"}/>
                                }
                                {!selectedImage && myPic !== "" && <img src={myPic} alt=""/>}
                                {selectedImage && <img src={URL.createObjectURL(selectedImage)} alt="user profile"/> }
                        </label>
                        <input type="email" placeholder="email" value={user_email} readOnly/>
                        
                        <fieldset>
                            <legend>Edit UserName</legend>
                            <input 
                            type="text" 
                            placeholder="enter your Username"
                            required
                            value={newUserHandle} 
                            onChange={e => {
                                if(e.target.value.length <= 20){
                                    setUserName(e.target.value)
                                }
                            }}/>
                        </fieldset>
                  
                        <input type="file" accept=".jpg, .jpeg, .png" id="file" style={{display: "none"}} onChange={e => SetSelectedImage(e.target.files[0])}/>
                        
                    </form>
                </div>

                <div className="aboutblogger flex-column1">
                    <fieldset>
                        <legend>About you / bio</legend>
                        <textarea rows={6} placeholder="how do you want others to know you. write your bio here..." value={aboutText} onChange={e => setAboutText(e.target.value)}/>
                    </fieldset>
                </div>

                <div className="arrangeformbtn">
                    <button style={{backgroundColor:"white", borderRadius:"10px", cursor:"pointer", padding:"10px", fontWeight:"bold", border:"none"}} onClick={updateAccount}>
                        Update Profile
                    </button>
                </div>


                <div className="arrangeformbtn flex-row2" style={{gap:"10px", flexWrap:"wrap"}}>
                    <button style={{border:"none", backgroundColor:"white", borderRadius:"10px", cursor:"pointer", padding:"10px", fontWeight:"bold", color:"#0E78F9"}} 
                    onClick={verifyUserCredential}>
                        Change Password
                    </button>

                    <button style={{border:"none", backgroundColor:"white", borderRadius:"10px", cursor:"pointer", padding:"10px", fontWeight:"bold", color:"#0E78F9"}} 
                    onClick={()=>dispatch({type: actionConts2.OPTIONAL_DIALOG, payload: true})}>
                        Sign Out
                    </button>
                </div>

                <div style={{display: "flex",flex:"1",gap:"5px", marginBottom:"3em", marginTop:"20px", padding:"10px"}}>
                    <input type="checkbox" id="remembermydetails" checked={checked} onChange={handlePersistLogin} />
                    <label htmlFor="remembermydetails">
                        <h4 style={{color:"white", padding:"10px"}}>Keep me Logged In always. Make sure you trust this device or else click to remove this settings.</h4>
                    </label>
                </div>
             

                {
                    success &&
                    <div className="toast">
                        <span style={{color:"white",fontWeight:"bold"}}>Pofile Updated Successfully. close and refresh page</span> 
                        <HbrCloseIcon width={"2em"} height={"2em"} fillColour={"white"} handleClick={()=>setSuccess(false)}/>
                    </div>
                }
        </div>
     ):(
        <ChangePassword
        user_email={user_email}
        onSuccess={()=>setChangePasswd(false)}
        />
     );
}
export default UpdateProfile;